import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    paddingRight: '12px'
  },
  content: {
    padding: '0 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }
});
